module.exports = __webpack_public_path__ + "static/img/cert-title.60ed0de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/oneHourCode/cert-title.png
// module id = qvuQ
// module chunks = 1